module.exports = __webpack_public_path__ + "static/halifaxPartnership-logo-e45bb0933ca89952ecdf7daf0c3b9c52.png";